/**
 * Copyright (c) 2026 Farelanes LLC. All rights reserved.
 *
 * UI: Nav Bar.
 */

import React from "react";
import { NavBarBrand } from "./NavBarBrand";
import {useAuth0} from "@auth0/auth0-react";
import NavTabs from "./NavBarTabs";

export const NavBar = () => {
    const { isLoading } = useAuth0();

    if (isLoading) {
        return <div className="fl-tabs" style={{ visibility: 'hidden', height: 0, overflow: 'hidden' }} />;
    }

    return (
        <div className="fl-tabs">
            <div className="row">
                <div className="col-md-4">
                    <NavBarBrand/>
                </div>
                <div className="col-md-8">
                    <NavTabs/>
                </div>
            </div>
        </div>
    );
};
